module.exports = {
  name: 'xiaomig',
  frame: {
    tel:'Tel',
    email: 'Email',
    hours: 'At your service 7x24 hours',
    weixin: 'WeChat',
    address: 'Address',
  },
  header: {
    home: 'HOME',
    us: 'ABOUT',
    product: 'PRODUCT',
    Quality: 'QUALITY',
    News: 'NEWS',
    career_opportunities: 'CAREER OPPORTUNITIES',
    contact_us: 'CONTACT US',
  },
  contactus: {
    title: 'CONTACT US',
    name: 'Name',
    name_msg: 'Please type in your name',
    email: 'Email',
    email_msg: 'please input your email',
    tel: 'Tel',
    tel_msg: 'Please enter the phone',
    content: 'message',
    content_msg: 'Please enter information',
    submit: 'submit',
    setEmailMsg: 'E-mail can not be empty',
    setEmailFormatMsg: 'Email format error',
    setTelErrMsg: 'The phone number is wrong',
    success: 'Submitted successfully',
  },
  jobchance: {
    career_opportunities: 'CAREER OPPORTUNITIES',
    job_responsibilities: 'Job Responsibilities',
    job_requirements: 'Job Requirements',
    submit_resume: 'Submit Resume',
  },
  newsinformation : {
    title: 'NEWS',
    qiyngNews: 'Company News',
    tradenews: 'Industry News'
  },
  quality:{
    quality:'QUALITY'
  },
  about:{
    about:'About Us',
    honor:'HONOR',
    technology:'TECHNOLOGY',
  },
  home:{
    ser : 'PRODUCTS AND SERVICE',
    qy_adv: 'WINSTAR ADVANTAGES',
    contact_us:'CONTACT US',
    get_a_quote:'GET A QUOTE'
  },
  sof:{
    ser: 'Product',
    all_products:'ALL PRODUCTS',
    main_products :'MAIN PRODUCTS',
    product_category: 'Product Category',
    all: 'All',
    keyword: 'Keyword',
    search: 'Search',
    inspection_report: 'Inspection Report',

    zh_name:'Chinese Name',
    en_name:'English Name',
    plant_source:'Plant Source',
    product_specifications:'Product Specifications',
    molecular_formula:'Molecular Formula',
    molecular_weight:'Molecular Weight',
  },
  comp:{
    join_us:'JOIN US'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js